import { render, staticRenderFns } from "./SectionLiveGeneral.vue?vue&type=template&id=37b045fe&scoped=true&"
import script from "./SectionLiveGeneral.vue?vue&type=script&lang=js&"
export * from "./SectionLiveGeneral.vue?vue&type=script&lang=js&"
import style0 from "./SectionLiveGeneral.vue?vue&type=style&index=0&id=37b045fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b045fe",
  null
  
)

export default component.exports